// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__ZE87h","right":"styles_right__2V3Pf"};